/** Identidade CERES centralizada: componentes nunca repetem nome ou cor. */
export const BRANDING = {
  productName: 'CERES CRM',
  category: 'CRM comercial B2B',
  // Assinatura oficial do Manual de Marca v1.0 (CERES-UX-001).
  tagline: 'Clareza para cultivar relações.',
  promise: 'Do primeiro contato ao crescimento sustentável.',
  company: 'BugKillers',
  legalLine: 'CERES CRM — um produto BugKillers',
} as const;

export const COR_DA_MARCA = '#0E3A25';
